import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import * as utils from '@utils'

class SimpleTable extends React.Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props)
    }

    needTextAlignRight(key) {
        if (/amount/.test(key)) return false

        const regEx = /money|bet|profit|transfer|tax/
        return regEx.test(key.toLowerCase())
    }

    render() {
        return (
            <Paper className={this.props.classes.root}>
                <Toolbar className={this.props.title ? '' : this.props.classes.hide}>
                    <div className={this.props.classes.title}>
                        <Typography variant="h6">{this.props.title}</Typography>
                    </div>
                </Toolbar>
                <Table className={this.props.classes.table}>
                    <TableHead>
                        <TableRow>
                            {this.props.column.map((key) => (
                                <TableCell
                                    key={key}
                                    style={{
                                        textAlign: this.needTextAlignRight(key) ? 'right' : 'left',
                                    }}>
                                    {utils.t(key, this.props.componentName)}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow className={Object.keys(this.props.data).length === 0 ? '' : this.props.classes.hide}>
                            <TableCell colSpan={Object.keys(this.props.column).length} align="center">
                                {utils.t('no_data')}
                            </TableCell>
                        </TableRow>
                        <TableRow className={Object.keys(this.props.data).length === 0 ? this.props.classes.hide : ''}>
                            {this.props.column.map((key) => (
                                <TableCell
                                    key={key}
                                    style={{
                                        textAlign: this.needTextAlignRight(key) ? 'right' : 'left',
                                    }}>
                                    {key in this.props.data ? this.props.data[key] : 'null'}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

const styles = (_theme) => {
    return {
        root: {
            width: '100%',
            overflowX: 'auto',
        },
        title: {
            flex: '0 0 auto',
        },
        table: {
            minWidth: 650,
        },
        hide: {
            display: 'none',
        },
    }
}

SimpleTable.propTypes = {
    classes: PropTypes.object.isRequired,
    componentName: PropTypes.string,
    title: PropTypes.string,
    column: PropTypes.array,
    data: PropTypes.object,
}

export default hoc(styles)(SimpleTable)
